<template>
  <div :class="classes">
     <pt-page-title title="批量发放"></pt-page-title>
     <pt-sub-title title="选择用户信息"></pt-sub-title>
     <table :class="$style['selected-old-customer-and-new-customer']">
       <pt-form-list-item label="发放对象：">
         {{grantObj}}
         </pt-form-list-item>
     </table>
     <template v-if="isShowOldCustomer">
     <pt-sub-title title="老用户奖励"></pt-sub-title>
     <customer-grant-form v-model="oldMessage" ref="customerGrantFormOld" fromPage="batch" customerType="old"></customer-grant-form>
     </template>
     <template  v-if="isShowNewCustomer">
     <pt-sub-title title="新用户奖励"></pt-sub-title>
     <customer-grant-form v-model="newMessage" ref="customerGrantFormNew" fromPage="batch"  customerType="new"></customer-grant-form>
     </template>
     <div>

      <div class="button-div">
        <el-button type="primary" @click="submit" :loading="submitLoading">提交</el-button>
        <el-button type="primary" @click="cancel" plain>取消</el-button>
    </div>
     </div>
  </div>
</template>

<script>
// 组件class前缀
import customerGrantForm from './customer-grant-form'
import { cashCount } from '@/utils/formUtils'
const prefixCls = 'pt-batch-grant'
export default {
  name: 'pt-batch-grant',
  components: {
    customerGrantForm
  },

  props: {
    type: {
      type: String,
      default: ''
    },
    statisticeData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    submitLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    fromOld () {
      return this.$refs.customerGrantFormOld
    },
    fromNew () {
      return this.$refs.customerGrantFormNew
    },
    // 是否显示老用户发放表单
    isShowOldCustomer () {
      return (this.type === 'ALL' || this.type === 'OLD') && this.statisticeData.canRewardOldUserTotal > 0
    },
    // 是否显示新用户
    isShowNewCustomer () {
      return (this.type === 'ALL' || this.type === 'NEW') && this.statisticeData.canRewardNewUserTotal > 0
    }
  },
  data () {
    return {
      records: [],
      customerCount: 0,
      newCustomerCount: 0,
      oldCustomerCount: 0,
      isRefresh: false,
      grantObj: '',
      oldMessage: {},
      newMessage: {}
    }
  },
  watch: {
    statisticeData: {
      handler: function (val) {
        if (this.type === 'ALL') {
          this.grantObj = '已选择' + val.canRewardUserTotal + '个脐荐康用户，其中老用户' + val.canRewardOldUserTotal + '人，新用户' +
           val.canRewardNewUserTotal + '人'
        } else if (this.type === 'OLD') {
          this.grantObj = '已选择老用户' + val.canRewardOldUserTotal + '人'
        } else if (this.type === 'NEW') {
          this.grantObj = '已选择新用户' + val.canRewardNewUserTotal + '人'
        }
      },
      deep: true
    }
  },
  methods: {
    submit () {
      let data = {
        ids: [],
        newDiscountCoupons: [],
        oldDiscountCoupons: [],
        isBatch: true
      }
      this.records.forEach(item => {
        data.ids.push(item.id)
      })
      data.newMoney = this.isBatch ? null : cashCount(this.newMessage.amount)
      data.oldMoney = this.isBatch ? null : cashCount(this.oldMessage.amount)
      if (this.newMessage.discountCoupons && this.newMessage.discountCoupons.length > 0) {
        this.newMessage.discountCoupons.forEach(item => {
          data.newDiscountCoupons.push({ id: item.id, amount: item.amount })
        })
      }
      if (this.oldMessage.discountCoupons && this.oldMessage.discountCoupons.length > 0) {
        this.oldMessage.discountCoupons.forEach(item => {
          data.oldDiscountCoupons.push({ id: item.id, amount: item.amount })
        })
      }

      this.$emit('submit', data)
    },
    cancel () {
      history.go(-1)
    }
  },
  created () {
    if (this.$route.params.recordMessage && this.$route.params.recordMessage.length > 0) {
      localStorage.setItem('records', JSON.stringify(this.$route.params.recordMessage))
      this.records = this.$route.params.recordMessage
    } else {
      this.records = JSON.parse(localStorage.getItem('records'))
    }
    this.records.forEach(item => {
      if (item.newCustomer) {
        this.newCustomerCount++
      }
      if (item.oldCustomer) {
        this.oldCustomerCount++
      }
    })
    this.customerCount = this.newCustomerCount + this.oldCustomerCount
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.selected-old-customer-and-new-customer{
  padding: 0 20px;
}
</style>
